export const paths = {
  login: "/login",
  dash: "/dashboard",
  editContent: "/edit-content",
  coupon: "/coupon",
  mainAttractionDetail: (id) => `/main-attraction/${id}`,
  constraints: "/constraints",
  constraintsList: "/constraints-list",
  shackClosing: "/shack-closing",
  orders: "/orders",
};
